    window.addEventListener( "DOMContentLoaded" , ()=> {

            document.getelementsbyclassname("gender").forEach(
                r => r.addEventListener("change" ,
                         e => console.log( "change:" + e.target.value)
                    )
            );

    });


// --------------------▼　誕生日　▼--------------------

var time = new Date();
var year = time.getFullYear();

for (var i = year; i >= 1900; i--) {
  createOptionElements(i,'year');
}

for (var i = 1; i <= 12; i++) {
  createOptionElements(i,'month');
}

for (var i = 1; i <= 31; i++) {
  createOptionElements(i,'day');
}

function createOptionElements(num,parentId){
    var doc = document.createElement('option');
    doc.value = doc.innerHTML = num;
    document.getElementById(parentId).appendChild(doc);
}

// --------------------▲　誕生日　▲--------------------


// --------------------▼　パスワード一致　▼--------------------

function Validate() {
  
  var password = document.getElementById("RegisterForm-password").value;

  let elements = document.getElementsByClassName('gender');
  let len = elements.length;
  let genderValue = '';
  
  for (let i = 0; i < len; i++){
      if (elements.item(i).checked){
          genderValue = elements.item(i).value;
      }
  }
  
   var yearValue = document.getElementById("year").value+"年";
   var monthValue = document.getElementById("month").value+"月";
   var dayValue = document.getElementById("day").value+"日";

  var checks = document.getElementsByClassName('giftfor');
  var giftforValue = '';
  
  for ( i = 0; i < 3; i++) {
    if ( checks[i].checked === true ) {
        giftforValue += checks[i].value + ",";
    }
  }


  document.getElementById("brthday_set").value=yearValue+monthValue+dayValue;
  document.getElementById("giftfor_set").value=giftforValue;
  document.getElementById("customer_tags").value=giftforValue+yearValue+","+monthValue+","+dayValue+","+genderValue;
  
        var confirmPassword = document.getElementById("RegisterForm-password-confirm").value;
        if (password != confirmPassword) {
            document.getElementById("output-message").innerHTML = "パスワードが一致しません";
            return false;
        } else{
          var target = document.getElementById("create_customer");
          target.method = "post";
          target.submit();
        }
       
}


// --------------------▲　パスワード一致　▲--------------------